import React from 'react';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { ROW_HEIGHT } from '@/experiences/sales-portal/domain/prospects/screens/prospects/components/prospects-manager-view/manager-table-constants';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';

interface ManagerTableRowProps<TData> {
  highlighted?: boolean;
  index: number;
  row: Row<TData>;
}

const ManagerTableRowComponent = <TData,>({
  highlighted = false,
  index,
  row,
}: ManagerTableRowProps<TData>) => {
  const [styles] = useStyles();

  return (
    <TableRow index={index} style={styles.row}>
      {row.getVisibleCells().map((cell: Cell<TData, unknown>) => (
        <TableCell
          cell={cell}
          key={cell.id}
          style={highlighted ? styles.highlightedCell : styles.cell}
        >
          {flexRender(cell.column.columnDef.cell, {
            ...cell.getContext(),
            index,
          })}
        </TableCell>
      ))}
    </TableRow>
  );
};

export const ManagerTableRow = React.memo(
  ManagerTableRowComponent,
) as typeof ManagerTableRowComponent;

const useStyles = createStyles((theme) => ({
  cell: {
    backgroundColor: theme.sk.color.bg.primary.default,
  },
  highlightedCell: {
    backgroundColor: theme.sk.color.bg.primary.hover,
  },
  row: {
    minHeight: ROW_HEIGHT,
  },
}));
